module.exports = __webpack_public_path__ + "static/media/aviator1.2be0925d.gif";